import React from 'react'
import "./style.css";
import { Button } from "react-bootstrap";
import saveIcon from "../../assets/images/saveIcon.svg";
import CheckCircleFillIcon from "../../assets/images/check-circle-fill-icon.svg"
import LoadIcon from "../../assets/images/load-icon.svg"


interface FloatButtonProps {
    draftStatus: string;
    onSaveDraft: () => void;
}

const FloatButton: React.FC<FloatButtonProps> = ({ draftStatus, onSaveDraft}) => {
  return (
    <>
    {draftStatus === 'notStarted' ? (
      <Button 
      variant="secondary"
       className='float-button saving-draft-button'>
     <img src={saveIcon} alt="Save Icon" className="save-icon" />
      Save Draft</Button>
    ) : draftStatus === 'modified' ? (
        <Button 
        variant="success"
        type="submit"
        className='float-button save-draft-button px-5 py-2 rounded-pill save-btn'
        onClick={onSaveDraft}>
            <img src={saveIcon} alt="Save Icon" className="save-icon" />
        Save Draft</Button>
    ) : draftStatus === 'started' ? (
        <Button 
        variant="secondary"
         className='float-button saving-draft-button'>
        <img src={LoadIcon} alt="Saving Icon" className="save-icon" />
        Saving...</Button>
    ) : (
        <Button 
        variant="success"
        className='float-button saved-draft-button px-5 py-2 rounded-pill save-btn'>
        <img src={CheckCircleFillIcon} alt="Saved Icon" className="save-icon" />
        Saved Just Now</Button>
    )}
    </>
  )
}

export default FloatButton